module.exports = __webpack_public_path__ + "static/media/31.b1d2ba7f.jpg";